import React, { useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import PlayButtonIcon from '../../assets/icons/play.svg';

function MyVideo({ url }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasBeenStarted, setHasBeenStarted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const isImage = useMemo(() => ['png', 'jpg'].includes(url.slice(-3)), [url]);

  const onPlayClick = () => {
    if (!videoRef.current || !isLoaded) return;

    videoRef.current.play();
    if (!hasBeenStarted) setHasBeenStarted(true);
  };

  return (
    <div className={classNames(styles.videoWrapper, { [styles.videoWrapperHidden]: !isLoaded })}>
      {isImage ? (
        <img
          src={url}
          alt="image"
          className={styles.image}
        />
      ) : (
        <video
          ref={videoRef}
          hidden={!isLoaded}
          className={styles.video}
          width="100%"
          onLoadedData={() => setIsLoaded(true)}
          onPause={() => setIsPlaying(false)}
          onPlay={() => setIsPlaying(true)}
          controls={hasBeenStarted}
          src={url}
          muted
        >
          Sorry, your browser doesn’t support embedded videos.
        </video>
      )}
      <div className={classNames(styles.overlay, { [styles.overlayHidden]: !isLoaded || isPlaying })}>
        <div onClick={onPlayClick} className={classNames(styles.playButton, 'pressableLight')}>
          <img className={styles.playButtonImg} src={PlayButtonIcon} alt="Play" />
        </div>
      </div>

    </div>
  );
}

export default MyVideo;
